(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["es-birthstone-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('es-birthstone-guide')) return;
    class BirthstoneGuide extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-birthstone-open]');
        const options = { signal: this.controller.signal };
        this.trigger.addEventListener('click', () => {
          this.dialog.showModal();
          document.documentElement.classList.add('es-birthstone-open');
        }, options);
        this.querySelector('[data-birthstone-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('es-birthstone-open');
          this.trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.remove('es-birthstone-open');
        this.controller?.abort();
        this.controller = null;
      }
    }
    customElements.define('es-birthstone-guide', BirthstoneGuide);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["es-product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select',event=>{
    const details=event.target.closest?.('.es-details__item');
    if(details)details.open=true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["es-stock-status"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('es-stock-status')) return;
    class StockStatus extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = this.closest('form');
        this.quantity = this.querySelector('[data-stock-quantity]');
        this.label = this.querySelector('[data-stock-label]');
        try {
          const variants = JSON.parse(this.querySelector('[data-stock-data]').textContent);
          this.variants = new Map(variants.map(variant => [String(variant.id), variant]));
          this.update();
          this.form?.addEventListener('change', () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          }, { signal: this.controller.signal });
        } catch {
          this.hidden = true;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.controller = null;
      }
      update() {
        const selector = this.form?.querySelector('select[name="id"], input[name="id"]');
        const variant = this.variants.get(selector?.value || this.dataset.variant);
        const limit = Number(this.dataset.threshold);
        const count = Number(variant?.quantity);
        const visible = Boolean(variant?.available && variant.tracked && variant.policy === 'deny' && Number.isInteger(count) && count > 0 && count <= limit);
        this.quantity.textContent = visible ? this.dataset.message.replace('__count__', String(count)) : this.dataset.availableMessage;
        this.label.textContent = visible ? this.dataset.label : '';
        this.classList.toggle('es-stock-status--low', visible);
        this.hidden = !variant?.available;
      }
    }
    customElements.define('es-stock-status', StockStatus);
  })();
  } catch(e) { console.error(e); }
})();

})();
